import { apiClientAuth } from "../http/httpClient";


export function MessageApi(contentType = "application/json")
{
    const https = apiClientAuth(contentType);

    return {
        
       /**
        * @route   POST /api/messages
        * @desc    Créer un nouveau message de contact : pas besoin d'authentification
        * @access  Public - auth required
        * @middleware validateCreateMessage - Valide les données du message
        * @middleware handleValidationErrors - Gère les erreurs de validation
        */
        insert : (data) => https.post("/api/messages", data), 

        

      };
}

